<div class="trust-summary">
  <ng-container *appLoad="let data of load$; trackingName: 'trust-summary'">
    <!-- details -->
    <h4>Details</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="trust-summary__details">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Name"
              [text]="data.trust.name"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Type"
              [text]="data.trust.trustType"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <country-wrapper>
              <ng-template country="NZ">
                <app-summary-field
                  label="NZBN"
                  [text]="data.trust.businessNumber | nzbn"></app-summary-field>
              </ng-template>
              <ng-template countryDefault>
                <app-summary-field
                  label="ABN"
                  [text]="data.trust.businessNumber | abn"></app-summary-field>
              </ng-template>
            </country-wrapper>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Foundation date"
              [text]="
                data.trust.foundationDate | date : 'dd/MM/yyyy'
              "></app-summary-field>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-4"
            *ngIf="'NZ' | disableForCountries">
            <app-summary-field
              label="Jurisdiction"
              [text]="data.trust.jurisdiction"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Settlor name"
              [text]="data.trust.settlorName"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Manager / appointer name"
              [text]="data.trust.managerName"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Status"
              [text]="data.trust.status"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Contact type"
              [text]="data.trust.contactType"></app-summary-field>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-4"
            *ngIf="data.trust.contactType | displayAffiliateId">
            <app-summary-field
              label="Affiliate ID"
              [text]="data.trust.nmbAffiliateId"></app-summary-field>
          </div>
        </div>
      </div>
      <div class="trust-summary__action">
        <lds-icon-button icon="edit" appearance="default" [isRounded]="true">
        </lds-icon-button>
      </div>
    </lds-card>

    <!-- trustees -->
    <ng-container *ngIf="data.trust.trustees && data.trust.trustees.length > 0">
      <h4>Trustees</h4>

      <lds-card [isClickable]="true" (click)="edit()">
        <div class="company-summary__details mb-md">
          <!-- TODO: responsive layout on small devices [future release] -->
          <div class="row">
            <div class="col-6">
              <div class="text-label">Name</div>
            </div>
          </div>

          <ng-container *ngFor="let trustee of data.trust.trustees">
            <div class="row">
              <div class="col-6">
                <div class="text-data">{{ contactName(trustee) }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </lds-card>
    </ng-container>

    <!-- beneficiaries -->
    <ng-container
      *ngIf="
        data.trust.beneficiaries != null && data.trust.beneficiaries.length > 0
      ">
      <h4>Beneficiaries</h4>

      <lds-card [isClickable]="true" (click)="edit()">
        <div class="company-summary__details mb-md">
          <!-- TODO: responsive layout on small devices [future release] -->
          <div class="row">
            <div class="col-6">
              <div class="text-label">Name</div>
            </div>
            <div class="col">
              <div class="text-label">Share (%)</div>
            </div>
          </div>

          <ng-container *ngFor="let beneficiary of data.trust.beneficiaries">
            <div class="row">
              <div class="col-6">
                <div class="text-data">{{ contactName(beneficiary.id) }}</div>
              </div>
              <div class="col">
                <div class="text-data">
                  {{ beneficiary.ownership | percent }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </lds-card>
    </ng-container>

    <div class="tags-summary">
      <h4>Tags</h4>
      <lds-card>
        <div class="tags-summary__details">
          <app-tag-input
          [entityId]="trustId"
          [entityType]="TagEntityType.Trusts"
            [readonly]="false"
            [showLabel]="false">
          </app-tag-input>
        </div>
      </lds-card>
    </div>

    <h4>Referrer Arrangement</h4>

    <spark-contacts-referrer-arrangement-summary
      [referrerArrangement]="data.trust.referrerArrangement"
      (clicked)="edit()">
    </spark-contacts-referrer-arrangement-summary>
  </ng-container>
</div>
